/* eslint-disable
max-len,
no-mixed-spaces-and-tabs,
react/jsx-indent,
react/jsx-first-prop-new-line,
*/

import React, { PureComponent, PropTypes } from 'react';
import cn from 'classnames';

import styles from './styles.scss';

export class Laptop extends PureComponent {
  render() {
    return (
      <div className={this.props.className}>
        <svg version="1.1" id="Macbook" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 409.9 243.6" preserveAspectRatio="xMaxYMax slice">
        <g>
          <path className={styles.st0} d="M374.2,9v208.8H36.6V9c0-2.6,2.1-4.7,4.7-4.7h328.2C372.1,4.4,374.2,6.5,374.2,9z" />
          <rect x="52.4" y="20.2" className={styles.st1} width="305.9" height="189.6" />
          <path className={styles.st0} d="M405.7,217.9v15.9c0,2.9-2.3,5.2-5.2,5.2H10.3c-2.9,0-5.2-2.3-5.2-5.2v-15.9H405.7z" />
          <path className={styles.st2} d="M162.1,217.9h86.6v6.2c0,2.7-2.2,4.9-4.9,4.9H167c-2.7,0-4.9-2.2-4.9-4.9V217.9z" />
          <rect x="52.4" y="20.1" className={styles.st3} width="305.9" height="16.2" />
          <g>
            <path
              className={styles.st2}
              d="M64.9,26.4h-1.6c0,0-0.2,0.1-0.2,0.3l-0.4,4.6c0,0,0,0.3-0.2,0.3h-1.1c0,0-0.2,0-0.2-0.3l0.4-4.6c0,0,0-0.3-0.2-0.3h-1.6c0,0-0.2,0-0.2-0.3l0.1-0.6c0,0,0-0.3,0.3-0.3h5c0,0,0.3,0,0.3,0.1l0,0.8C65.2,26.2,65.1,26.4,64.9,26.4zM70.4,31.3c0,0,0.1,0.4-0.2,0.4h-1c0,0-0.2,0-0.3-0.3l-0.3-1c0,0-0.1-0.1-0.3-0.1h-2.1c0,0-0.3,0-0.3,0.2l-0.5,1c0,0-0.1,0.2-0.4,0.2H64c0,0-0.2,0-0.2-0.2l2.9-6c0,0,0.1-0.2,0.3-0.2h0.3h0.9c0,0,0.2,0,0.3,0.2L70.4,31.3z M68.1,28.9l-0.5-1.7c-0.1-0.2-0.1-0.1-0.1-0.1c-0.1,0-0.1,0.1-0.1,0.1L66.5,29c-0.1,0.2,0.1,0.3,0.1,0.3h1.3C68.2,29.2,68.1,28.9,68.1,28.9zM90.5,31.7h-1c0,0-0.2,0-0.3-0.3l-0.3-1c0,0-0.1-0.1-0.3-0.1h-2.1c0,0-0.3,0-0.3,0.2l-0.5,1c0,0-0.1,0.2-0.4,0.2h-0.9c0,0-0.2,0-0.2-0.2l2.9-6c0,0,0.1-0.2,0.3-0.2h0.3h0.9c0,0,0.2,0,0.3,0.2l1.9,5.8C90.7,31.3,90.9,31.6,90.5,31.7z M88.5,28.9L88,27.2c-0.1-0.2-0.1-0.1-0.1-0.1c-0.1,0-0.1,0.1-0.1,0.1L86.9,29c-0.1,0.2,0.1,0.3,0.1,0.3h1.3C88.6,29.2,88.5,28.9,88.5,28.9zM71.2,31.4c0,0.2,0.2,0.2,0.2,0.2h1c0.2,0,0.2-0.2,0.2-0.2l0.2-3.1l-1.3-2.1L71.2,31.4z M77.3,24.7h-0.9c-0.3,0-0.3,0.3-0.3,0.3l-0.3,4c0,0.1,0,0.2-0.1,0.2c0,0-0.1,0-0.1,0c-0.1,0-0.2-0.1-0.2-0.1l-2.2-3.6c-0.1-0.3-0.3-0.3-0.3-0.3h-1.1c-0.1,0-0.2,0.1-0.2,0.1l3.7,6.1c0.1,0.1,0.2,0.2,0.2,0.2c0,0,0.1,0,0.1,0h1c0.3,0,0.3-0.2,0.3-0.2l0.4-6.5C77.5,24.8,77.3,24.7,77.3,24.7z M84,30.1c0,0-0.8,1.7-2.9,1.6h-2.6h-0.1c0,0-0.3,0-0.2-0.3l0.4-5.8c0,0,0-0.2,0.3-0.2h2.8c0,0,1.5,0,2.3,1c0.1,0.1,0.2,0.4,0.3,0.5C84.4,27.2,84.8,28.5,84,30.1z M82.9,27.9c0-0.1,0-0.3-0.1-0.3c-0.3-1.2-1.6-1.1-1.6-1.1h-1c-0.4,0-0.3,0.2-0.3,0.2l-0.2,3.5c0,0.3,0.3,0.3,0.3,0.3h1.2c0.1,0,0.4-0.1,0.4-0.1C83,30.1,83,28.5,82.9,27.9z"
            />
          </g>
          <path className={styles.st2} d="M347.2,209.8v-144c0-1.1-0.9-2-2-2H65.8c-1.1,0-2,0.9-2,2v144" />
          <path
            className={styles.st2}
            d="M93.2,55.4H67.4c-0.8,0-1.5-0.7-1.5-1.5v-4.6c0-0.8,0.7-1.5,1.5-1.5h25.7c0.8,0,1.5,0.7,1.5,1.5v4.6C94.7,54.7,94,55.4,93.2,55.4z"
          />
          <path
            className={styles.st2}
            d="M137.1,55.4H99.3c-0.8,0-1.5-0.7-1.5-1.5v-4.6c0-0.8,0.7-1.5,1.5-1.5h37.8c0.8,0,1.5,0.7,1.5,1.5v4.6C138.6,54.7,137.9,55.4,137.1,55.4z"
          />
          <path
            className={styles.st4}
            d="M100.1,83.5v23c0,1.5-1.3,2.8-2.8,2.8h-23c-1.5,0-2.8-1.3-2.8-2.8v-23c0-1.6,1.3-2.8,2.8-2.8h23C98.8,80.7,100.1,82,100.1,83.5z"
          />
          <g>
            <g>
              <path
                className={styles.st5}
                d="M82.7,108.8c-0.1,0.2-0.3,0.4-0.5,0.6h-4.3c-0.5-0.5-0.8-1.1-0.9-1.7c-0.1-0.4,0-0.8,0.1-1.2c0.1-0.3,0.2-0.6,0.4-0.9c0.9-1.4,2.8-1.9,4.2-1C83.1,105.5,83.6,107.4,82.7,108.8z"
              />
            </g>
            <g>
              <polygon className={styles.st6} points="82.7,108.8 82.3,109.4 75.3,109.4 77.1,106.1 77.5,105.6 " />
            </g>
            <g>
              <polygon className={styles.st6} points="89,108.8 89.4,109.4 96.4,109.4 94.5,106.1 94.2,105.6 " />
            </g>
            <g>
              <path
                className={styles.st7}
                d="M94.5,106.8l0.1,2.6H77l0-1.7l0-0.9c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0.1-0.4c0.2-0.9,0.8-1.6,1.5-1.8l2.5-0.9l1.2-0.4l0.1,0c0,0,0,0,0,0h0c0.2,0.1,0.4-0.5,0.7-1.2c0.1-0.3,0.2-0.6,0.3-0.9c0.3-0.8,0.6-1.6,0.9-1.6h2.4c0.3,0,0.7,0.8,1,1.7c0.1,0.3,0.2,0.6,0.3,0.9c0.3,0.7,0.5,1.2,0.7,1l0.1,0l1.3,0.5l2.6,0.9C93.8,104.6,94.5,105.6,94.5,106.8z"
              />
            </g>
            <g>
              <path
                className={styles.st5}
                d="M89,98.9v4.7c0,1.7-1.6,2.6-3.4,2.6c-1.8,0-3.2-0.9-3.2-2.6v-4.7c0-1.7,1.5-3.1,3.3-3.1c0.9,0,1.7,0.4,2.3,0.9C88.6,97.2,89,98,89,98.9z"
              />
            </g>
            <g className={styles.st8}>
              <path
                className={styles.st9}
                d="M89,98.9v2.6c-0.9,0.6-2,0.9-3.2,0.9c-1.2,0-2.4-0.4-3.4-1v-2.5c0-1.7,1.5-3.1,3.3-3.1c0.9,0,1.7,0.4,2.3,0.9C88.6,97.2,89,98,89,98.9z"
              />
            </g>
            <g>
              <path
                className={styles.st9}
                d="M91.8,91.1v4.3c0,3.3-2.7,6-6,6c-3.3,0-6-2.7-6-6v-4.3c0-2.1,1.1-3.9,2.7-5c0.5-0.3,1.1-0.6,1.7-0.8c0.5-0.1,1-0.2,1.5-0.2c1.7,0,3.2,0.7,4.2,1.8c0.9,0.9,1.6,2.2,1.7,3.6C91.8,90.7,91.8,90.9,91.8,91.1z"
              />
            </g>
            <g>
              <circle className={styles.st9} cx="91.8" cy="93.8" r="1.3" />
            </g>
            <g>
              <circle className={styles.st9} cx="79.8" cy="93.8" r="1.3" />
            </g>
            <g>
              <circle className={styles.st10} cx="83.1" cy="93.8" r="0.8" />
            </g>
            <g>
              <circle className={styles.st10} cx="88.4" cy="93.8" r="0.8" />
            </g>
            <g className={styles.st8}>
              <path
                className={styles.st5}
                d="M85.7,98.7c-1.1,0-2.2-0.6-2.7-1.6c-0.1-0.2,0-0.4,0.1-0.4c0.2-0.1,0.4,0,0.4,0.1c0.4,0.8,1.3,1.3,2.2,1.3c0.9,0,1.7-0.5,2.2-1.3c0.1-0.2,0.3-0.2,0.4-0.1c0.2,0.1,0.2,0.3,0.1,0.4C87.9,98,86.8,98.7,85.7,98.7z"
              />
            </g>
            <g>
              <path className={styles.st11} d="M82.1,102.5l3.5,3.7l-1,1.9l-3.5-4.7c0,0,0-0.1,0-0.1l0.8-0.7C82,102.4,82,102.4,82.1,102.5z" />
            </g>
            <g>
              <path className={styles.st11} d="M89.3,102.5l-3.6,3.7l1.1,1.9l3.6-4.7c0,0,0-0.1,0-0.2l-0.9-0.7C89.4,102.4,89.4,102.4,89.3,102.5z" />
            </g>
            <g>
              <path
                className={styles.st10}
                d="M81.7,92.7c-0.1,0-0.3-0.1-0.3-0.2c0-0.2,0.1-0.3,0.2-0.4l1.9-0.5c0.2,0,0.3,0.1,0.4,0.2c0,0.2-0.1,0.3-0.2,0.4L81.7,92.7C81.8,92.7,81.7,92.7,81.7,92.7z"
              />
            </g>
            <g>
              <path
                className={styles.st12}
                d="M80.1,95.7c0.3,0,0.5-0.2,0.5-0.5v-3.6c0-1.7,0.9-3.3,2.3-4.3c0.5-0.3,1-0.5,1.5-0.7c0.4-0.1,0.9-0.2,1.3-0.2c1.4,0,2.7,0.5,3.6,1.5c0.8,0.8,1.4,1.9,1.5,3.1c0,0.2,0,0.4,0,0.5v3.6c0,0.3,0.2,0.5,0.5,0.5l0,0c0.3,0,0.5-0.2,0.5-0.5v-3.6c0-0.2,0-0.4,0-0.7c-0.1-1.4-0.8-2.7-1.8-3.7c-1.1-1.1-2.7-1.8-4.4-1.8c-0.5,0-1.1,0.1-1.6,0.2c-0.6,0.2-1.2,0.4-1.8,0.8c-1.7,1.1-2.8,3-2.8,5.2v3.6C79.6,95.5,79.8,95.7,80.1,95.7L80.1,95.7z"
              />
            </g>
            <g>
              <path
                className={styles.st10}
                d="M89.5,92.7C89.5,92.7,89.5,92.7,89.5,92.7l-2-0.5c-0.2,0-0.3-0.2-0.2-0.4c0-0.2,0.2-0.3,0.4-0.2l1.9,0.5c0.2,0,0.3,0.2,0.2,0.4C89.8,92.6,89.7,92.7,89.5,92.7z"
              />
            </g>
            <g>
              <path
                className={styles.st13}
                d="M82.2,86.9c0,0-1.3-0.6-2.4,0.4c-1,1-1.4,2.4-0.7,4c0.3,0.8,0.4,0.7,0.4,0.7l0.6,0.9c0,0,0.5-3.2,1.8-4.5C82.3,88,82.4,87.4,82.2,86.9L82.2,86.9z"
              />
            </g>
            <g>
              <path className={styles.st14} d="M94,86.3c0,0,2.5,5.8-7.9,4.8c-5.5-0.5-5.6-2.9-5.6-2.9s1-5.9,5.6-4.3C93.7,86.6,94,86.3,94,86.3z" />
            </g>
            <g className={styles.st8}>
              <path
                className={styles.st5}
                d="M85.7,96.5c-0.1,0-0.3-0.1-0.3-0.2c0-0.2,0.1-0.3,0.2-0.4c0.1,0,0.3-0.1,0.3-0.2c0,0,0.1-0.1,0.1-0.2c0-0.2-0.3-0.3-0.6-0.2c-0.2,0-0.3-0.1-0.4-0.2c0-0.2,0.1-0.3,0.2-0.4c0.6-0.2,1.2,0.1,1.4,0.6c0.1,0.3,0,0.6-0.2,0.8C86.3,96.2,86.1,96.4,85.7,96.5C85.8,96.5,85.8,96.5,85.7,96.5z"
              />
            </g>
          </g>
          <path
            className={styles.st4}
            d="M100.1,126.5v23c0,1.5-1.3,2.8-2.8,2.8h-23c-1.5,0-2.8-1.3-2.8-2.8v-23c0-1.6,1.3-2.8,2.8-2.8h23C98.8,123.7,100.1,124.9,100.1,126.5z"
          />
          <g>
            <g>
              <path
                className={styles.st5}
                d="M82.7,151.8c-0.1,0.2-0.3,0.4-0.5,0.6h-4.3c-0.5-0.5-0.8-1.1-0.9-1.7c-0.1-0.4,0-0.8,0.1-1.2c0.1-0.3,0.2-0.6,0.4-0.9c0.9-1.5,2.8-1.9,4.2-1C83.1,148.5,83.6,150.4,82.7,151.8z"
              />
            </g>
            <g>
              <polygon className={styles.st6} points="82.7,151.8 82.3,152.4 75.3,152.4 77.1,149.1 77.5,148.6 " />
            </g>
            <g>
              <polygon className={styles.st6} points="89,151.8 89.4,152.4 96.4,152.4 94.5,149.1 94.2,148.6 " />
            </g>
            <g>
              <path className={styles.st7} d="M76.2,177.1c0,0,0,0.1,0,0.1h0L76.2,177.1L76.2,177.1C76.2,177.1,76.2,177.1,76.2,177.1z" />
              <path className={styles.st7}
                d="M94.5,149.8l0.1,2.6H77l0-1.7l0-0.9c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0.1-0.4c0.2-0.9,0.8-1.6,1.5-1.8l2.5-0.9l1.2-0.4l0.1,0c0,0,0,0,0,0h0c0.2,0.1,0.4-0.5,0.7-1.2c0.1-0.3,0.2-0.6,0.3-0.9c0.3-0.8,0.6-1.6,0.9-1.6h2.4c0.3,0,0.7,0.8,1,1.7c0.1,0.3,0.2,0.6,0.3,0.9c0.3,0.7,0.5,1.2,0.7,1l0.1,0l0,0l1.3,0.5l2.6,0.9C93.8,147.6,94.5,148.6,94.5,149.8z"
              />
              <polygon className={styles.st7} points="95.3,177.2 95.3,177.2 95.3,177.2 " />
            </g>
            <g>
              <path
                className={styles.st5}
                d="M89,141.8v4.7c0,1.7-1.6,2.6-3.4,2.6c-1.8,0-3.2-0.9-3.2-2.6v-4.7c0-1.7,1.5-3.1,3.3-3.1c0.9,0,1.7,0.4,2.3,0.9S89,141,89,141.8z"
              />
            </g>
            <g className={styles.st8}>
              <path
                className={styles.st9}
                d="M89,141.8v2.6c-0.9,0.6-2,0.9-3.2,0.9c-1.2,0-2.4-0.4-3.4-1v-2.5c0-1.7,1.5-3.1,3.3-3.1c0.9,0,1.7,0.4,2.3,0.9S89,141,89,141.8z"
              />
            </g>
            <g>
              <path className={styles.st9}
                d="M91.8,134.1v4.3c0,3.3-2.7,6-6,6c-3.3,0-6-2.7-6-6v-4.3c0-2.1,1.1-3.9,2.7-5c0.5-0.3,1.1-0.6,1.7-0.8c0.5-0.1,1-0.2,1.5-0.2c1.7,0,3.2,0.7,4.2,1.8c0.9,0.9,1.6,2.2,1.7,3.6C91.8,133.6,91.8,133.8,91.8,134.1z"
              />
            </g>
            <g>
              <circle className={styles.st9} cx="91.8" cy="136.8" r="1.3" />
            </g>
            <g>
              <circle className={styles.st9} cx="79.8" cy="136.8" r="1.3" />
            </g>
            <g>
              <circle className={styles.st10} cx="83.1" cy="136.7" r="0.8" />
            </g>
            <g>
              <circle className={styles.st10} cx="88.4" cy="136.7" r="0.8" />
            </g>
            <g className={styles.st8}>
              <path className={styles.st5}
                d="M85.7,141.6c-1.1,0-2.2-0.6-2.7-1.6c-0.1-0.2,0-0.4,0.1-0.4c0.2-0.1,0.4,0,0.4,0.1c0.4,0.8,1.3,1.3,2.2,1.3c0.9,0,1.7-0.5,2.2-1.3c0.1-0.2,0.3-0.2,0.4-0.1c0.2,0.1,0.2,0.3,0.1,0.4C87.9,141,86.8,141.6,85.7,141.6z"
              />
            </g>
            <g>
              <path className={styles.st11} d="M82.1,145.5l3.5,3.7l-1,1.9l-3.5-4.7c0,0,0-0.1,0-0.1l0.8-0.7C82,145.4,82,145.4,82.1,145.5z" />
            </g>
            <g>
              <path className={styles.st11} d="M89.3,145.5l-3.6,3.7l1.1,1.9l3.6-4.7c0,0,0-0.1,0-0.2l-0.9-0.7C89.4,145.4,89.4,145.4,89.3,145.5z" />
            </g>
            <g>
              <path className={styles.st10}
                d="M81.7,135.7c-0.1,0-0.3-0.1-0.3-0.2c0-0.2,0.1-0.3,0.2-0.4l1.9-0.5c0.2,0,0.3,0.1,0.4,0.2c0,0.2-0.1,0.3-0.2,0.4L81.7,135.7C81.8,135.7,81.7,135.7,81.7,135.7z"
              />
            </g>
            <g>
              <path className={styles.st12}
                d="M80.1,138.7c0.3,0,0.5-0.2,0.5-0.5v-3.6c0-1.7,0.9-3.3,2.3-4.3c0.5-0.3,1-0.5,1.5-0.7c0.4-0.1,0.9-0.2,1.3-0.2c1.4,0,2.7,0.5,3.6,1.5c0.8,0.8,1.4,1.9,1.5,3.1c0,0.2,0,0.4,0,0.5v3.6c0,0.3,0.2,0.5,0.5,0.5l0,0c0.3,0,0.5-0.2,0.5-0.5v-3.6c0-0.2,0-0.4,0-0.7c-0.1-1.4-0.8-2.7-1.8-3.7c-1.1-1.1-2.7-1.8-4.4-1.8c-0.5,0-1.1,0.1-1.6,0.2c-0.6,0.2-1.2,0.4-1.8,0.8c-1.7,1.1-2.8,3-2.8,5.2v3.6C79.6,138.4,79.8,138.7,80.1,138.7L80.1,138.7z"
              />
            </g>
            <g>
              <path className={styles.st10}
                d="M89.5,135.6C89.5,135.6,89.5,135.6,89.5,135.6l-2-0.5c-0.2,0-0.3-0.2-0.2-0.4c0-0.2,0.2-0.3,0.4-0.2l1.9,0.5c0.2,0,0.3,0.2,0.2,0.4C89.8,135.5,89.7,135.6,89.5,135.6z"
              />
            </g>
            <g>
              <path className={styles.st13}
                d="M82.2,129.8c0,0-1.3-0.6-2.4,0.4c-1,1-1.4,2.4-0.7,4c0.3,0.8,0.4,0.7,0.4,0.7l0.6,0.9c0,0,0.5-3.2,1.8-4.5C82.3,131,82.4,130.3,82.2,129.8L82.2,129.8z"
              />
            </g>
            <g>
              <path className={styles.st14} d="M94,129.3c0,0,2.5,5.8-7.9,4.8c-5.5-0.5-5.6-2.9-5.6-2.9s1-5.9,5.6-4.3C93.7,129.6,94,129.3,94,129.3z" />
            </g>
            <g className={styles.st8}>
              <path className={styles.st5}
                d="M85.7,139.4c-0.1,0-0.3-0.1-0.3-0.2c0-0.2,0.1-0.3,0.2-0.4c0.1,0,0.3-0.1,0.3-0.2c0,0,0.1-0.1,0.1-0.2c0-0.2-0.3-0.3-0.6-0.2c-0.2,0-0.3-0.1-0.4-0.2c0-0.2,0.1-0.3,0.2-0.4c0.6-0.2,1.2,0.1,1.4,0.6c0.1,0.3,0,0.6-0.2,0.8C86.3,139.2,86.1,139.4,85.7,139.4C85.8,139.4,85.8,139.4,85.7,139.4z"
              />
            </g>
          </g>
          <path className={styles.st4}
            d="M100.1,169.5v23.1c0,1.5-1.3,2.8-2.8,2.8h-2.7l-0.1-2.6c0-1.2-0.7-2.2-1.6-2.5l-2.6-0.9l0.1-0.1c0,0,0-0.1,0-0.2l-0.9-0.7c0,0-0.1,0-0.1,0l-0.3,0.3v-2.4c1.6-1,2.7-2.8,2.8-4.8c0.1-0.1,0.2-0.2,0.2-0.4v-0.1c0.7-0.1,1.2-0.7,1.2-1.3c0-0.7-0.5-1.2-1.2-1.3v-0.9c0-0.2,0-0.4,0-0.7c0-0.1,0-0.1,0-0.2c3.4-1.3,2.1-4.4,2.1-4.4s-0.3,0.3-7.9-2.4c-3-1.1-4.5,1.1-5.1,2.8c-0.4,0-0.8,0.2-1.2,0.6c-1,1-1.4,2.4-0.7,4c0.3,0.8,0.4,0.7,0.4,0.7l0.1,0.2v0.3c-0.6,0.1-1.1,0.7-1.1,1.3c0,0.7,0.5,1.2,1.1,1.3v0.1c0,0.2,0.1,0.3,0.2,0.4c0.1,2,1.1,3.7,2.6,4.7v2.5l-0.3-0.3c0,0-0.1,0-0.2,0l-0.8,0.7c0,0,0,0.1,0,0.1l0.1,0.1l-2.5,0.9c-0.8,0.3-1.3,1-1.5,1.8l-1.9,3.3h-1.1c-1.5,0-2.8-1.3-2.8-2.8v-23.1c0-1.5,1.3-2.8,2.8-2.8h23C98.8,166.7,100.1,167.9,100.1,169.5z"
          />
          <path className={styles.st4}
            d="M94.6,195.3H75.3l1.9-3.3c0.2-0.9,0.8-1.6,1.5-1.8l2.5-0.9l-0.1-0.1c0,0,0-0.1,0-0.1l0.8-0.7c0,0,0.1,0,0.2,0l0.3,0.3v-2.5c-1.5-1-2.5-2.7-2.6-4.7c-0.1-0.1-0.2-0.2-0.2-0.4v-0.1c-0.6-0.1-1.1-0.7-1.1-1.3c0-0.7,0.5-1.2,1.1-1.3v-0.3l-0.1-0.2c0,0-0.1,0.1-0.4-0.7c-0.7-1.6-0.3-3,0.7-4c0.4-0.4,0.8-0.5,1.2-0.6c0.7-1.6,2.1-3.8,5.1-2.8c7.6,2.6,7.9,2.4,7.9,2.4s1.3,3.1-2.1,4.4c0,0.1,0,0.1,0,0.2c0,0.2,0,0.4,0,0.7v0.9c0.7,0.1,1.2,0.7,1.2,1.3c0,0.7-0.5,1.2-1.2,1.3v0.1c0,0.2-0.1,0.3-0.2,0.4c-0.1,2-1.2,3.8-2.8,4.8v2.4l0.3-0.3c0,0,0.1,0,0.1,0l0.9,0.7c0,0,0.1,0.1,0,0.2l-0.1,0.1l2.6,0.9c0.9,0.3,1.6,1.4,1.6,2.5L94.6,195.3z"
          />
          <g>
            <g>
              <path className={styles.st5}
                d="M82.7,194.8c-0.1,0.2-0.3,0.4-0.4,0.6h-4.3c-0.5-0.5-0.8-1.1-0.9-1.7c-0.1-0.4,0-0.8,0.1-1.2c0.1-0.2,0.1-0.5,0.2-0.7l0.1-0.2c0.9-1.4,2.8-1.9,4.2-1C83.1,191.4,83.6,193.3,82.7,194.8z"
              />
            </g>
            <g>
              <polygon className={styles.st6} points="82.7,194.8 82.3,195.3 75.3,195.3 77.1,192.1 77.3,191.7 77.5,191.5 " />
            </g>
            <g>
              <polygon className={styles.st6} points="89,194.8 89.4,195.3 96.4,195.3 94.5,192.1 94.3,191.7 94.2,191.5 " />
            </g>
            <g>
              <path className={styles.st7}
                d="M94.6,195.3H77l0-1.7l0-0.9c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0.1-0.3c0.2-0.9,0.8-1.6,1.5-1.8l2.5-0.9l1.2-0.4l0.1,0c0,0,0,0,0,0h0c0.2,0.1,0.4-0.5,0.7-1.2c0.1-0.3,0.2-0.6,0.3-0.9c0.3-0.8,0.6-1.6,0.9-1.6h2.4c0.3,0,0.7,0.8,1,1.7c0.1,0.3,0.2,0.6,0.3,0.9c0.3,0.7,0.5,1.2,0.7,1l0.1,0l1.3,0.5l2.6,0.9c0.9,0.3,1.6,1.4,1.6,2.5L94.6,195.3z"
              />
            </g>
            <g>
              <path className={styles.st5}
                d="M89,184.8v4.7c0,1.7-1.5,2.6-3.3,2.6h-0.1c-1.8,0-3.2-0.9-3.2-2.6v-4.7c0-0.7,0.2-1.3,0.6-1.8c0.1-0.2,0.2-0.3,0.4-0.5c0.6-0.6,1.4-0.9,2.3-0.9c0.1,0,0.1,0,0.2,0c0.2,0,0.5,0.1,0.7,0.1c0.5,0.1,1,0.4,1.4,0.8c0,0,0,0,0,0c0.1,0.1,0.3,0.3,0.4,0.4C88.8,183.5,89,184.1,89,184.8z"
              />
            </g>
            <g className={styles.st8}>
              <path className={styles.st9}
                d="M89,184.8v2.6c-0.3,0.2-0.5,0.3-0.8,0.4c-0.7,0.3-1.5,0.5-2.4,0.5c-0.9,0-1.8-0.2-2.6-0.6c-0.3-0.1-0.5-0.3-0.8-0.5v-2.5c0-0.7,0.2-1.3,0.6-1.8c0.1-0.2,0.2-0.3,0.4-0.5c0.6-0.6,1.4-0.9,2.3-0.9c0.1,0,0.1,0,0.2,0c0.2,0,0.5,0.1,0.7,0.1c0.5,0.1,1,0.4,1.4,0.8c0,0,0,0,0,0c0.1,0.1,0.3,0.3,0.4,0.4C88.8,183.5,89,184.1,89,184.8z"
              />
            </g>
            <g>
              <path className={styles.st9}
                d="M91.8,177v4.3c0,0.1,0,0.2,0,0.2c-0.1,2-1.2,3.8-2.8,4.8c-0.4,0.2-0.7,0.4-1.2,0.6c-0.6,0.2-1.3,0.4-2.1,0.4c-0.8,0-1.6-0.2-2.3-0.5c-0.4-0.2-0.8-0.4-1.1-0.6c-1.5-1-2.5-2.7-2.6-4.7c0-0.1,0-0.2,0-0.2V177c0-0.8,0.1-1.5,0.4-2.1c0,0,0,0,0,0c0.1-0.2,0.2-0.5,0.3-0.7c0,0,0,0,0,0s0,0,0,0c0.3-0.6,0.7-1.1,1.2-1.5c0.2-0.2,0.5-0.5,0.8-0.7c0.5-0.3,1.1-0.6,1.7-0.8c0.5-0.1,1-0.2,1.5-0.2c1.7,0,3.2,0.7,4.2,1.8c0.5,0.5,1,1.2,1.3,1.9c0.2,0.5,0.4,1.1,0.4,1.7c0,0.1,0,0.2,0,0.3C91.8,176.8,91.8,176.9,91.8,177z"
              />
            </g>
            <g>
              <path className={styles.st9}
                d="M93.1,179.7c0,0.7-0.5,1.2-1.2,1.3c-0.1,0-0.1,0-0.2,0c-0.3,0-0.6-0.1-0.9-0.3c-0.3-0.2-0.5-0.6-0.5-1c0-0.4,0.2-0.8,0.5-1c0.2-0.2,0.5-0.3,0.9-0.3c0.1,0,0.1,0,0.2,0C92.6,178.5,93.1,179.1,93.1,179.7z"
              />
            </g>
            <g>
              <path className={styles.st9}
                d="M81.1,179.7c0,0.4-0.2,0.8-0.5,1c-0.2,0.2-0.5,0.3-0.9,0.3c-0.1,0-0.1,0-0.2,0c-0.6-0.1-1.1-0.7-1.1-1.3c0-0.7,0.5-1.2,1.1-1.3c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0.1,0,0.2,0,0.3,0.1c0.2,0,0.4,0.1,0.5,0.3C81,179,81.1,179.3,81.1,179.7z"
              />
            </g>
            <g>
              <circle className={styles.st10} cx="83.1" cy="179.7" r="0.8" />
            </g>
            <g>
              <circle className={styles.st10} cx="88.4" cy="179.7" r="0.8" />
            </g>
            <g className={styles.st8}>
              <path className={styles.st5}
                d="M85.7,184.6c-1.1,0-2.2-0.6-2.7-1.6c-0.1-0.2,0-0.4,0.1-0.4c0.2-0.1,0.4,0,0.4,0.1c0.4,0.8,1.3,1.3,2.2,1.3c0.9,0,1.7-0.5,2.2-1.3c0.1-0.2,0.3-0.2,0.4-0.1c0.2,0.1,0.2,0.3,0.1,0.4C87.9,184,86.8,184.6,85.7,184.6z"
              />
            </g>
            <g>
              <path className={styles.st11}
                d="M85.6,192.1l-0.3,0.5l-0.7,1.3l-3.5-4.7l-0.1-0.1c0,0,0-0.1,0-0.1l0.8-0.7c0,0,0.1,0,0.2,0l0.3,0.3l0.1,0.1h0L85.6,192.1z"
              />
            </g>
            <g>
              <path className={styles.st11}
                d="M90.4,189.2L90.4,189.2l-3.6,4.7l-0.7-1.3l-0.3-0.6l3.2-3.3l0.1-0.1l0.3-0.3c0,0,0.1,0,0.1,0l0.9,0.7C90.4,189.1,90.4,189.2,90.4,189.2z"
              />
            </g>
            <g className={styles.st15}>
              <rect x="85.4" y="192.1" className={styles.st6} width="0.7" height="3.2" />
            </g>
            <g>
              <path className={styles.st10}
                d="M81.7,178.7c-0.1,0-0.3-0.1-0.3-0.2c0-0.2,0.1-0.3,0.2-0.4l1.9-0.5c0.2,0,0.3,0.1,0.4,0.2c0,0.2-0.1,0.3-0.2,0.4L81.7,178.7C81.8,178.7,81.7,178.7,81.7,178.7z"
              />
            </g>
            <g>
              <path className={styles.st12}
                d="M92,177.5v3.6c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.1-0.3,0.1c-0.3,0-0.5-0.2-0.5-0.5v-3.6c0-0.2,0-0.3,0-0.5v0c-0.1-1.2-0.6-2.2-1.5-3.1c-1-1-2.2-1.5-3.6-1.5c-0.5,0-0.9,0-1.3,0.2c-0.5,0.1-1,0.4-1.5,0.7c-0.3,0.2-0.5,0.4-0.8,0.6c-0.5,0.4-0.8,0.9-1.1,1.5c0,0.1-0.1,0.2-0.1,0.3c-0.2,0.6-0.3,1.2-0.3,1.9v3.6c0,0.3-0.2,0.5-0.5,0.5c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.2-0.2-0.2-0.4v-3.6c0-0.9,0.2-1.8,0.6-2.6c0,0,0,0,0,0c0.1-0.2,0.2-0.4,0.3-0.6c0.4-0.6,0.8-1.1,1.4-1.6c0.2-0.1,0.3-0.3,0.5-0.4c0.6-0.4,1.2-0.6,1.8-0.8c0.5-0.1,1-0.2,1.6-0.2c1.7,0,3.2,0.7,4.4,1.8c0.5,0.5,0.9,1,1.2,1.6c0.3,0.6,0.5,1.2,0.6,2c0,0.1,0,0.1,0,0.2C92,177.1,92,177.3,92,177.5z"
              />
            </g>
            <g>
              <path className={styles.st10}
                d="M89.5,178.6C89.5,178.6,89.5,178.6,89.5,178.6l-2-0.5c-0.2,0-0.3-0.2-0.2-0.4c0-0.2,0.2-0.3,0.4-0.2l1.9,0.5c0.2,0,0.3,0.2,0.2,0.4C89.8,178.5,89.7,178.6,89.5,178.6z"
              />
            </g>
            <g>
              <path className={styles.st13}
                d="M82.2,173.9c-0.1,0.2-0.2,0.3-0.3,0.5c-0.3,0.3-0.5,0.6-0.7,1c0,0.1-0.1,0.2-0.1,0.3c-0.5,1-0.8,2.2-0.9,2.8c0,0.2-0.1,0.3-0.1,0.3l-0.3-0.4l0,0l-0.2-0.3l-0.1-0.2c0,0-0.1,0.1-0.4-0.7c-0.7-1.6-0.3-3,0.7-4c0.4-0.4,0.8-0.5,1.2-0.6c0.3,0,0.5,0,0.7,0c0.1,0,0.1,0,0.2,0c0.2,0,0.3,0.1,0.3,0.1C82.3,173.1,82.3,173.5,82.2,173.9z"
              />
            </g>
            <g>
              <path className={styles.st14}
                d="M91.9,176.7c0,0-0.1,0-0.1,0c-0.3,0.1-0.6,0.2-0.9,0.2v0c-1.2,0.2-2.7,0.3-4.8,0.1c-2.9-0.3-4.3-1-4.9-1.8c-0.5-0.5-0.6-0.9-0.6-1.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0s0,0,0,0c0-0.1,0.2-0.8,0.5-1.5c0.7-1.6,2.1-3.8,5.1-2.8c7.6,2.6,7.9,2.4,7.9,2.4S95.3,175.4,91.9,176.7z"
              />
            </g>
            <g className={styles.st8}>
              <path className={styles.st5}
                d="M85.7,182.4c-0.1,0-0.3-0.1-0.3-0.2c0-0.2,0.1-0.3,0.2-0.4c0.1,0,0.3-0.1,0.3-0.2c0,0,0.1-0.1,0.1-0.2c0-0.2-0.3-0.3-0.6-0.2c-0.2,0-0.3-0.1-0.4-0.2c0-0.2,0.1-0.3,0.2-0.4c0.6-0.2,1.2,0.1,1.4,0.6c0.1,0.3,0,0.6-0.2,0.8C86.3,182.2,86.1,182.3,85.7,182.4C85.8,182.4,85.8,182.4,85.7,182.4z"
              />
            </g>
          </g>
          <path className={styles.st16}
            d="M299.3,103.6h-54.2c-0.7,0-1.2-0.5-1.2-1.2V89.3c0-0.7,0.5-1.2,1.2-1.2h54.2c0.7,0,1.2,0.5,1.2,1.2v13.1C300.5,103,300,103.6,299.3,103.6z"
          />
          <path className={styles.st17}
            d="M201.6,103.6h-25.9c-0.7,0-1.2-0.5-1.2-1.2V89.3c0-0.7,0.5-1.2,1.2-1.2h25.9c0.7,0,1.2,0.5,1.2,1.2v13.1C202.8,103,202.3,103.6,201.6,103.6z"
          />
          <path className={styles.st17}
            d="M236.7,103.6h-25.9c-0.7,0-1.2-0.5-1.2-1.2V89.3c0-0.7,0.5-1.2,1.2-1.2h25.9c0.7,0,1.2,0.5,1.2,1.2v13.1C237.9,103,237.4,103.6,236.7,103.6z"
          />
          <g>
            <path className={styles.st17}
              d="M338.1,108.1h-29.3c-0.7,0-1.3-0.6-1.3-1.3v-22c0-0.7,0.6-1.3,1.3-1.3h29.3c0.7,0,1.3,0.6,1.3,1.3v22C339.4,107.5,338.8,108.1,338.1,108.1z"
            />
            <g>
              <rect x="312.1" y="89.3" className={styles.st18} width="15.1" height="2.8" />
              <rect x="312.1" y="94.4" className={styles.st18} width="15.1" height="2.8" />
              <rect x="312.1" y="99.5" className={styles.st18} width="15.1" height="2.8" />
              <circle className={styles.st18} cx="332.8" cy="90.7" r="1.4" />
              <circle className={styles.st18} cx="332.8" cy="95.8" r="1.4" />
              <circle className={styles.st18} cx="332.8" cy="100.9" r="1.4" />
            </g>
          </g>
          <path className={styles.st16}
            d="M299.3,145.5h-54.2c-0.7,0-1.2-0.5-1.2-1.2v-13.1c0-0.7,0.5-1.2,1.2-1.2h54.2c0.7,0,1.2,0.5,1.2,1.2v13.1C300.5,145,300,145.5,299.3,145.5z"
          />
          <path className={styles.st17}
            d="M201.6,145.5h-25.9c-0.7,0-1.2-0.5-1.2-1.2v-13.1c0-0.7,0.5-1.2,1.2-1.2h25.9c0.7,0,1.2,0.5,1.2,1.2v13.1C202.8,145,202.3,145.5,201.6,145.5z"
          />
          <path className={styles.st17}
            d="M236.7,145.5h-25.9c-0.7,0-1.2-0.5-1.2-1.2v-13.1c0-0.7,0.5-1.2,1.2-1.2h25.9c0.7,0,1.2,0.5,1.2,1.2v13.1C237.9,145,237.4,145.5,236.7,145.5z"
          />
          <g>
            <path className={styles.st17}
              d="M338.1,150.1h-29.3c-0.7,0-1.3-0.6-1.3-1.3v-22c0-0.7,0.6-1.3,1.3-1.3h29.3c0.7,0,1.3,0.6,1.3,1.3v22C339.4,149.5,338.8,150.1,338.1,150.1z"
            />
            <g>
              <rect x="312.1" y="131.3" className={styles.st18} width="15.1" height="2.8" />
              <rect x="312.1" y="136.4" className={styles.st18} width="15.1" height="2.8" />
              <rect x="312.1" y="141.5" className={styles.st18} width="15.1" height="2.8" />
              <circle className={styles.st18} cx="332.8" cy="132.7" r="1.4" />
              <circle className={styles.st18} cx="332.8" cy="137.8" r="1.4" />
              <circle className={styles.st18} cx="332.8" cy="142.9" r="1.4" />
            </g>
          </g>
          <path className={styles.st16}
            d="M299.3,187.5h-54.2c-0.7,0-1.2-0.5-1.2-1.2v-13.1c0-0.7,0.5-1.2,1.2-1.2h54.2c0.7,0,1.2,0.5,1.2,1.2v13.1C300.5,187,300,187.5,299.3,187.5z"
          />
          <path className={styles.st17}
            d="M201.6,187.5h-25.9c-0.7,0-1.2-0.5-1.2-1.2v-13.1c0-0.7,0.5-1.2,1.2-1.2h25.9c0.7,0,1.2,0.5,1.2,1.2v13.1C202.8,187,202.3,187.5,201.6,187.5z"
          />
          <path className={styles.st17}
            d="M236.7,187.5h-25.9c-0.7,0-1.2-0.5-1.2-1.2v-13.1c0-0.7,0.5-1.2,1.2-1.2h25.9c0.7,0,1.2,0.5,1.2,1.2v13.1C237.9,187,237.4,187.5,236.7,187.5z"
          />
          <g>
            <path className={styles.st17}
              d="M338.1,192.1h-29.3c-0.7,0-1.3-0.6-1.3-1.3v-22c0-0.7,0.6-1.3,1.3-1.3h29.3c0.7,0,1.3,0.6,1.3,1.3v22C339.4,191.5,338.8,192.1,338.1,192.1z"
            />
            <g>
              <rect x="312.1" y="173.3" className={styles.st18} width="15.1" height="2.8" />
              <rect x="312.1" y="178.4" className={styles.st18} width="15.1" height="2.8" />
              <rect x="312.1" y="183.5" className={styles.st18} width="15.1" height="2.8" />
              <circle className={styles.st18} cx="332.8" cy="174.7" r="1.4" />
              <circle className={styles.st18} cx="332.8" cy="179.8" r="1.4" />
              <circle className={styles.st18} cx="332.8" cy="184.9" r="1.4" />
            </g>
          </g>
          <g>
            <path className={styles.st19}
              d="M165.7,103.6h-54.2c-0.7,0-1.2-0.5-1.2-1.2V89.3c0-0.7,0.5-1.2,1.2-1.2h54.2c0.7,0,1.2,0.5,1.2,1.2v13.1C166.9,103,166.3,103.6,165.7,103.6z"
            />
            <text transform="matrix(1 0 0 1 122.6068 100.1686)" className={cn(styles.st2, styles.st20, styles.st21)}>8:00</text>
          </g>
          <text transform="matrix(1 0 0 1 254.8221 100.1686)" className={cn(styles.st2, styles.st20, styles.st21)}>14:00</text>
          <g>
            <path className={styles.st19}
              d="M165.7,145.5h-54.2c-0.7,0-1.2-0.5-1.2-1.2v-13.1c0-0.7,0.5-1.2,1.2-1.2h54.2c0.7,0,1.2,0.5,1.2,1.2v13.1C166.9,145,166.3,145.5,165.7,145.5z"
            />
            <text transform="matrix(1 0 0 1 122.6068 141.4655)" className={cn(styles.st2, styles.st20, styles.st21)}>8:00</text>
          </g>
          <text transform="matrix(1 0 0 1 254.8221 141.4655)" className={cn(styles.st2, styles.st20, styles.st21)}>14:00</text>
          <g>
            <path className={styles.st19}
              d="M165.7,187.5h-54.2c-0.7,0-1.2-0.5-1.2-1.2v-13.1c0-0.7,0.5-1.2,1.2-1.2h54.2c0.7,0,1.2,0.5,1.2,1.2v13.1C166.9,187,166.3,187.5,165.7,187.5z"
            />
            <text transform="matrix(1 0 0 1 122.6068 183.4528)" className={cn(styles.st2, styles.st20, styles.st21)}>8:00</text>
          </g>
          <text transform="matrix(1 0 0 1 254.8221 183.4528)" className={cn(styles.st2, styles.st20, styles.st21)}>14:00</text>
          <text transform="matrix(1 0 0 1 177.5218 98.4811)" className={cn(styles.st22, styles.st20, styles.st23)}>10:00</text>
          <text transform="matrix(1 0 0 1 177.5218 140.4323)" className={cn(styles.st22, styles.st20, styles.st23)}>10:00</text>
          <text transform="matrix(1 0 0 1 177.5218 182.7126)" className={cn(styles.st22, styles.st20, styles.st23)}>10:00</text>
          <text transform="matrix(1 0 0 1 212.8143 98.5368)" className={cn(styles.st22, styles.st20, styles.st23)}>10:30</text>
          <text transform="matrix(1 0 0 1 212.8143 140.4313)" className={cn(styles.st22, styles.st20, styles.st23)}>10:30</text>
          <text transform="matrix(1 0 0 1 212.8143 182.3259)" className={cn(styles.st22, styles.st20, styles.st23)}>10:30</text>
        </g>
        </svg>
      </div>
    );
  }
}

Laptop.propTypes = {
  className: PropTypes.string,
};

export default Laptop;



// WEBPACK FOOTER //
// ./src/components/shared/laptop/index.jsx